import { Modal, Box, IconButton, Tooltip } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useNavigate } from "react-router-dom";
import { getBitacoraLeads } from "../../../store/clientes/thunkClientes";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { apiUrlImg } from "../../../api";

const InfoBox = ({ label, value }) => (
    <Box sx={{ flex: { xs: "1 0 45%", sm: "1 0 30%" } }}>
        <p>{label}</p>
        <strong>{value || "--"}</strong>
    </Box>
);

const formatDate = (dateString) => {
    const date = new Date(dateString);

    // Ajustar la fecha a la zona horaria de Costa Rica (UTC-6)
    const localDate = new Date(date.getTime() - 6 * 60 * 60 * 1000);

    // Extraer año, mes y día
    const year = localDate.getFullYear();
    const month = String(localDate.getMonth() + 1).padStart(2, "0");
    const day = String(localDate.getDate()).padStart(2, "0");

    // Extraer horas, minutos y segundos, ajustando al formato de 12 horas
    let hours = localDate.getHours();
    const minutes = String(localDate.getMinutes()).padStart(2, "0");
    const seconds = String(localDate.getSeconds()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // Si la hora es '0', que sea '12'
    hours = String(hours).padStart(2, "0");

    const formattedDate = `${year}-${month}-${day}`;
    const formattedTime = `${hours}:${minutes}:${seconds} ${ampm}`;

    return { formattedDate, formattedTime };
};

export const ModalCliente = ({ client, onClose }) => {
    const navigate = useNavigate(); // Hook para navegación
    const [BitacoraLeads, setBitacora] = useState([]);

    const handleCopySession = () => {
        navigator.clipboard
            .writeText(client.nombre_cliente || "--")
            .then(() => {
                console.log("Token copiado");
            })
            .catch((err) => {
                console.error("Error al copiar el token: ", err);
            });
    };

    const perfilUsuario = () => {
        navigate(`/clientes/perfil?data=${client.id_cliente}`);
    };

     const perfilEmpresa = () => {
         navigate(`/empresas/perfil?data=${client.idEmpresaRelacion}`);
     };

    // Configuración de campos en bloques de tres
    const clientDetails = [
        [
            { label: "Nombre cliente:", value: client.nombre_cliente || "--" },
            { label: "Nombre empresa:", value: client.nombre_empresa || "--" },
            { label: "Correo Cliente:", value: client.correo_cleinte || "--" },
        ],
        [
            { label: "Número de teléfono:", value: client.telefono_cliente || "--" },
            { label: "Tipo Cliente:", value: client.tipo_cliente_cliente || "--" },
            { label: "Crédito cliente:", value: client.credito_cliente || "--" },
        ],
        [
            { label: "Monto crédito:", value: client.Monto_credito || "--" },
            { label: "Ejecutivo:", value: client.ejecutivos_name || "--" },
            { label: "Estado Cliente:", value: client.esatdo_cliente === 1 ? "Activo" : "Inactivo" || "--" },
        ],

        [
            { label: "Hijos:", value: client.hijos || "--" },
            { label: "Notas Importantes:", value: client.notasImportantes || "--" },
            { label: "Puesto:", value: client.puesto || "--" },
        ],
    ];
    const empresa = [
        [
            { label: "Nombre empresa:", value: client.nombre_empresa || "--" },
            { label: "Razón social:", value: client.razon_social || "--" },
            { label: "Cédula jurídica:", value: client.cedula_juridica || "--" },
        ],
        [
            { label: "Página web:", value: client.pagina_web || "--" },
            { label: "Teléfono:", value: client.telefono || "--" },
            { label: "País:", value: client.pais || "--" },
        ],
        [
            { label: "Dirección física:", value: client.direccion_fisica || "--" },
            { label: "Industria:", value: client.industria || "--" },
            { label: "Tipo de cliente:", value: client.tipo_cliente_cliente || "--" },
        ],
        [
            { label: "Tiene crédito:", value: client.tiene_credito || "--" },
            { label: "Notas importantes:", value: client.notas_importantes_cliente_empresa || "--" },
            { label: "Correo Facturacion:", value: client.correo_cliente || "--" },
        ],
    ];

    const dispatch = useDispatch();

    const fetchBitacora = async (idLead) => {
        try {
            const result = await dispatch(getBitacoraLeads(idLead)); // Llama a la acción de Redux para obtener la bitácora del lead.
            setBitacora(result); // Almacena los resultados en el estado.

            const response = await fetch(`${apiUrlImg}${client.logoEmpresa}`);
            if (response.ok) {
                const imageBlob = await response.blob();
                document.querySelector("#logoempresas").src = URL.createObjectURL(imageBlob);
            } else {
                throw new Error("Failed to load image");
            }
        } catch (error) {
            console.error("Error fetching bitacora:", error); // Maneja cualquier error.
        }
    };
    useEffect(() => {
        if (client.id_cliente && client.id_cliente > 0) {
            fetchBitacora(client.id_cliente); // Ejecuta la solicitud para obtener la bitácora del lead.
        }
    }, [client.id_cliente]); // El efecto se ejecuta nuevamente si 'location.search' cambia.


    const sortedBitacora = [...BitacoraLeads].sort((a, b) => new Date(a.bitacora_creacion) - new Date(b.bitacora_creacion));

    return (
        <Modal open={Boolean(client)} onClose={onClose} className="modal fade show" aria-labelledby="exampleModalLongTitle" style={{ display: "block" }} aria-modal="true" role="dialog">
            <div className="modal-dialog" role="document" style={{ maxWidth: "80%", margin: "1.75rem auto" }}>
                <div className="modal-content">
                    <div className="modal-body">
                        <p className="mb-0" style={{ fontSize: window.innerWidth < 600 ? "16px" : "28px" }}>
                            Detalles del cliente
                        </p>
                        <Box display="flex" alignItems="center">
                            <p className="mb-0" style={{ marginRight: "10px" }}>
                                {client.nombre_cliente || "--"}
                            </p>
                            <Tooltip title="Copiar Token">
                                <IconButton onClick={handleCopySession} size="small">
                                    <ContentCopyIcon />
                                </IconButton>
                            </Tooltip>
                        </Box>
                        <br />
                        <div style={{ display: "flex", gap: "10px" }}>
                            <button type="button" onClick={() => perfilUsuario(client)} className="btn-shadow btn btn-primary">
                                Perfil Cliente
                            </button>
                            <button type="button" onClick={() => perfilEmpresa(client)} className="btn-shadow btn btn-secondary">
                                Perfil Empresa
                            </button>
                        </div>
                        <br />

                        {clientDetails.map((group, index) => (
                            <Box
                                key={index}
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    flexWrap: "wrap",
                                    borderBottom: "1px solid #ccc",
                                    pb: 2,
                                    mb: 2,
                                    gap: window.innerWidth < 600 ? "16px" : "0",
                                }}
                            >
                                {group.map((detail, i) => (
                                    <InfoBox key={i} label={detail.label} value={detail.value} />
                                ))}
                            </Box>
                        ))}
                        <p className="mb-0" style={{ fontSize: window.innerWidth < 600 ? "16px" : "28px" }}>
                            Detalles de empresa
                        </p>
                        <div className="chat-avtar d-inline-flex mx-auto">
                            <img id="logoempresas" alt="User image" className="img-fluid img-thumbnail" style={{ width: "200px", height: "auto", color: "transparent" }} />
                            <i className="chat-badge bg-success me-2 mb-2"></i>
                        </div>
                        {empresa.map((group, index) => (
                            <Box
                                key={index}
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    flexWrap: "wrap",
                                    borderBottom: "1px solid #ccc",
                                    pb: 2,
                                    mb: 2,
                                    gap: window.innerWidth < 600 ? "16px" : "0",
                                }}
                            >
                                {group.map((detail, i) => (
                                    <InfoBox key={i} label={detail.label} value={detail.value} />
                                ))}
                            </Box>
                        ))}

                        <div className="card-header">
                            <h5>Bitacora Seguimiento</h5>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                {sortedBitacora.length > 0 ? (
                                    BitacoraLeads.map((entry, idx) => {
                                        const { formattedDate } = formatDate(entry.bitacora_creacion);

                                        return (
                                            <div className="col-xl-4 col-sm-6" key={idx}>
                                                <div className="statistics-card-1 card">
                                                    <div className="card-header d-flex align-items-center justify-content-between py-3">
                                                        <h5>{entry.bitacora_nombreCliente}</h5>
                                                    </div>

                                                    <div className="card-body">
                                                        <img alt="img" width="63" height="134" decoding="async" data-nimg="1" className="img-fluid img-bg" src="https://light-able-react-light.vercel.app/_next/static/media/img-status-2.4d72f177.svg" style={{ color: "transparent" }} />
                                                        <div className="d-flex align-items-center">
                                                            <h5 className="f-w-300 d-flex align-items-center m-b-0">Detalles</h5>
                                                        </div>
                                                        <h6 className="mb-0">Accion: </h6> {entry.bitacora_detalle}
                                                        <br />
                                                        <h6 className="mb-0 me-2"> {formattedDate} </h6>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })
                                ) : (
                                    <p>No hay acciones recientes para este lead.</p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};
